import React from 'react'
import ReactMarkdown from 'react-markdown'

export default function Contents({ source }: any) {
  return <ReactMarkdown source={source.contents} />
}
